import * as React from 'react';
import { FC, useEffect } from 'react';

import { Box, Header, Pressable, Text } from '@rbilabs/universal-components';
import queryString from 'query-string';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { LayoutContainer } from 'components/layout/styled';
import Logo from 'components/logo';
import ConfettiFriesAnimation, {
  useConfettiFriesAnimation,
} from 'components/lottie-animations/confetti-fries';
import useAuth from 'hooks/auth/use-auth';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useAuthContext } from 'state/auth';
import { ModalAuthScreen } from 'state/auth/types';
import { portalToFooter } from 'state/mobile-footer';
import { portalToReplaceHeader } from 'state/mobile-header-nav';
import { routes } from 'utils/routing';

import { StyledActionButton, StyledBox, StyledLogo } from './styled';

export const WalmartLandingPage: FC<React.PropsWithChildren<{}>> = () => {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const { isAuthenticated } = useAuthContext();
  const { setModalAuthState, closeModalAuth } = useAuth();
  const { navigate } = useNavigation();
  const { triggerAnimation } = useConfettiFriesAnimation();

  const queryParams = queryString.parse(location.search);
  const authzCode = queryParams.authz;

  useEffect(() => {
    return () => {
      closeModalAuth();
    };
  }, [closeModalAuth]);

  if (!authzCode) {
    navigate(routes.base);
    return null;
  }

  const HiddenAppHeader = portalToReplaceHeader(() => null);
  const HiddenAppFooter = portalToFooter(() => {
    return (
      <Box padding="$4">
        <StyledActionButton
          onPress={() => {
            if (!isAuthenticated) {
              // TODO: Consider using the new openSignInModal function here
              setModalAuthState({
                screen: ModalAuthScreen.SIGN_IN,
              });
            }
            triggerAnimation();
          }}
        >
          {formatMessage({ id: 'getMyOffers' })}
        </StyledActionButton>
      </Box>
    );
  });

  return (
    <LayoutContainer isFullContainer={true}>
      <ConfettiFriesAnimation />

      <StyledBox>
        <Pressable onPress={() => navigate(routes.partnerships)}>
          <StyledLogo>
            <Logo padding="0" />
          </StyledLogo>
        </Pressable>
        <Header paddingTop="$4">Walmart+</Header>
        <Text>AuthZ: {queryParams.authz || 'Not found'}</Text>
      </StyledBox>
      <HiddenAppHeader />
      <HiddenAppFooter />
    </LayoutContainer>
  );
};
